(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jlb-cart-progress"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__jlbCartCtl) return;
    window.__jlbCartCtl = true;

    function EUR(c) { try { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); } catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; } }

    function renderBar(total) {
      var sec = document.querySelector('.jlb-cxp');
      if (!sec) return;
      var threshold = parseInt(sec.getAttribute('data-threshold'), 10) || 0;
      if (!threshold) return;
      var before = sec.getAttribute('data-before') || 'Plus que';
      var after = sec.getAttribute('data-after') || '';
      var reached = sec.getAttribute('data-reached') || 'Livraison offerte en point relais !';
      var remaining = threshold - total; if (remaining < 0) remaining = 0;
      var pct = Math.round(total * 100 / threshold); if (pct > 100) pct = 100; if (pct < 0) pct = 0;
      var fill = document.getElementById('jlbCxpFill');
      var txt = document.getElementById('jlbCxpText');
      if (fill) fill.style.width = pct + '%';
      if (txt) txt.innerHTML = remaining > 0
        ? (before + ' <strong>' + EUR(remaining) + '</strong> ' + after)
        : '<strong>' + reached + '</strong>';
    }

    var t1, t2;
    function updateBar() {
      clearTimeout(t1);
      t1 = setTimeout(function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) { if (c) renderBar(c.total_price); })
          .catch(function () {});
      }, 120);
    }

    function refreshExtras() {
      clearTimeout(t2);
      t2 = setTimeout(function () {
        fetch(window.location.pathname + '?sections=jlb_cart_extras', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data || data.jlb_cart_extras == null) return;
            var el = document.getElementById('shopify-section-jlb_cart_extras');
            if (!el) return;
            var d = document.createElement('div'); d.innerHTML = data.jlb_cart_extras;
            var inner = d.querySelector('#shopify-section-jlb_cart_extras');
            el.innerHTML = inner ? inner.innerHTML : data.jlb_cart_extras;
          })
          .catch(function () {});
      }, 250);
    }

    function onCartChange() { updateBar(); refreshExtras(); }

    // 1) Intercepte les requêtes panier (ajout depuis n'importe où, tiroir, etc.)
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var p = origFetch.apply(this, args);
      try {
        var u = (args[0] && args[0].url) || args[0] || '';
        if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
          p.then(function (res) { onCartChange(); return res; });
        }
      } catch (e) {}
      return p;
    };

    // 2) Observe le re-render natif du panier (changement de quantité / suppression)
    function observeCart() {
      var target = document.getElementById('shopify-section-cart-section') || document.getElementById('MainContent');
      if (!target) return;
      var mo = new MutationObserver(function () { updateBar(); refreshExtras(); });
      mo.observe(target, { childList: true, subtree: true });
    }

    // 3) Bouton "Ajouter" des suggestions (délégué, persiste)
    //    Ajoute l'article, puis met à jour la liste native du panier (cart-section),
    //    le récapitulatif, la pastille de l'en-tête, la barre et les suggestions.
    var CART_SECTION = 'cart-section';

    function sectionInner(html, id) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = d.querySelector('#shopify-section-' + id);
      return inner ? inner.innerHTML : html;
    }
    function countIn(root) {
      var el = root && root.querySelector('[ref="cartItemCount"]');
      if (!el) return null;
      var n = parseInt(el.textContent, 10);
      return isNaN(n) ? null : n;
    }
    function setHeaderCount(n) {
      document.querySelectorAll('.jlb-hdr__cart').forEach(function (a) {
        var b = a.querySelector('.jlb-hdr__cart-count');
        if (n > 0) {
          if (!b) { b = document.createElement('span'); b.className = 'jlb-hdr__cart-count'; a.appendChild(b); }
          b.textContent = n;
        } else if (b) { b.remove(); }
      });
    }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    function refreshCartSection(sections, itemCount) {
      var html = sections && sections[CART_SECTION];
      var getHtml = html ? Promise.resolve(html) : origFetch(window.location.pathname + '?sections=' + CART_SECTION, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d && d[CART_SECTION]; });
      return getHtml.then(function (h) {
        if (!h) throw new Error('no-section');
        var el = document.getElementById('shopify-section-' + CART_SECTION);
        if (!el) throw new Error('no-target');
        var fresh = document.createElement('div'); fresh.innerHTML = h;
        var expected = itemCount != null ? itemCount : countIn(fresh);
        var data = {}; data[CART_SECTION] = h;
        // a) Méthode native du thème : cart-items-component écoute "cart:update" et se met à jour (morph)
        try {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: 'jlb-cart-upsell', data: { source: 'jlb-cart-upsell', itemCount: expected, sections: data } } }));
        } catch (e) {}
        return wait(400).then(function () {
          // b) Contrôle : si la liste n'a pas bougé, remplacement direct de la section
          if (expected != null && countIn(el) !== expected) el.innerHTML = sectionInner(h, CART_SECTION);
          if (expected != null && countIn(el) !== null && countIn(el) !== expected) throw new Error('not-updated');
          return expected;
        });
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.jlb-cx__up-add');
      if (!btn || btn.disabled) return;
      var vid = btn.getAttribute('data-vid');
      if (!vid) return;
      var prev = btn.textContent;
      btn.disabled = true; btn.textContent = 'Ajout...';
      origFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: CART_SECTION, sections_url: window.location.pathname })
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error((d && d.description) || 'Produit indisponible.'); });
        return res.json().then(function (added) {
          btn.disabled = false; btn.textContent = prev;
          return origFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              var n = cart ? cart.item_count : null;
              if (n != null) setHeaderCount(n);
              if (cart) renderBar(cart.total_price);
              return refreshCartSection(added && added.sections, n);
            })
            .then(function () { refreshExtras(); })
            .catch(function () { window.location.reload(); });
        });
      }).catch(function (err) {
        var ee = document.getElementById('jlbCxError');
        if (ee) { ee.hidden = false; ee.textContent = err.message || 'Une erreur est survenue.'; }
        btn.disabled = false; btn.textContent = prev;
      });
    });

    // 4) Code promo (champ custom, fiable mobile) -> applique sans quitter la page
    function applyPromo() {
      var inp = document.getElementById('jlbPromoInput');
      if (!inp) return;
      var code = (inp.value || '').trim();
      if (!code) { inp.focus(); return; }
      var btn = document.getElementById('jlbPromoBtn');
      if (btn) { btn.disabled = true; btn.textContent = 'Application...'; }
      // Pose le cookie de réduction en arrière-plan, puis recharge le panier courant
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('#jlbPromoBtn')) { e.preventDefault(); applyPromo(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.id === 'jlbPromoInput') { e.preventDefault(); applyPromo(); }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { observeCart(); updateBar(); });
    } else { observeCart(); updateBar(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-chambre"] && !Shopify.designMode) return;
  try {
    
  // ── Wishlist ──
  (function() {
    var JLB_FAV_KEY = 'jlb_wishlist';
    function getFavHandles() {
      try { return JSON.parse(localStorage.getItem(JLB_FAV_KEY)) || []; } catch(e) { return []; }
    }
    window.jlbToggleFav = window.jlbToggleFav || function(e, handle) {
      e.preventDefault(); e.stopPropagation();
      var favs = getFavHandles();
      var idx = favs.indexOf(handle);
      var action = idx === -1 ? 'add' : 'remove';
      if (action === 'add') { favs.push(handle); } else { favs.splice(idx, 1); }
      localStorage.setItem(JLB_FAV_KEY, JSON.stringify(favs));
      e.currentTarget.classList.toggle('active', action === 'add');
      if (typeof window.jlbServerSync === 'function') window.jlbServerSync(handle, action);
    };
    document.addEventListener('DOMContentLoaded', function() {
      var favs = getFavHandles();
      document.querySelectorAll('.jlb-fav-btn[data-handle]').forEach(function(btn) {
        if (favs.indexOf(btn.dataset.handle) !== -1) btn.classList.add('active');
      });
    });
  })();

  // ── Reveal on scroll ──
  const reveals = document.querySelectorAll('.jlb-ch-reveal');
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); revealObs.unobserve(e.target); } });
  }, { threshold: 0.12 });
  reveals.forEach(el => revealObs.observe(el));

  // ── Essentiels carousel ──
  const track   = document.getElementById('jlbEssentielsTrack');
  const btnPrev = document.getElementById('jlbEssPrev');
  const btnNext = document.getElementById('jlbEssNext');

  if (track && btnPrev && btnNext) {
    const cards = track.querySelectorAll('.jlb-ch-ess-card');
    const total = cards.length;
    let current = 0;

    function scrollTo(idx) {
      current = Math.max(0, Math.min(idx, total - 1));
      cards[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    btnNext.addEventListener('click', () => scrollTo(current + 1));
    btnPrev.addEventListener('click', () => scrollTo(current - 1));

    track.addEventListener('scroll', () => {
      clearTimeout(track._t);
      track._t = setTimeout(() => {
        const cardW = cards[0].offsetWidth + 20;
        current = Math.round(track.scrollLeft / cardW);
      }, 80);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  var JLB_FAV_KEY = 'jlb_wishlist';
  function getFavHandles() {
    try { return JSON.parse(localStorage.getItem(JLB_FAV_KEY)) || []; } catch(e) { return []; }
  }
  window.jlbToggleFav = window.jlbToggleFav || function(e, handle) {
    e.preventDefault(); e.stopPropagation();
    var favs = getFavHandles();
    var idx = favs.indexOf(handle);
    var action = idx === -1 ? 'add' : 'remove';
    if (action === 'add') { favs.push(handle); } else { favs.splice(idx, 1); }
    localStorage.setItem(JLB_FAV_KEY, JSON.stringify(favs));
    e.currentTarget.classList.toggle('active', action === 'add');
    if (typeof window.jlbServerSync === 'function') window.jlbServerSync(handle, action);
  };
  document.addEventListener('DOMContentLoaded', function() {
    var favs = getFavHandles();
    document.querySelectorAll('.jlb-fav-btn[data-handle]').forEach(function(btn) {
      if (favs.indexOf(btn.dataset.handle) !== -1) btn.classList.add('active');
    });
    document.querySelectorAll('.jlb-card-rating[data-rating]').forEach(function(el) {
      var rating = parseFloat(el.dataset.rating) || 0;
      var count = parseInt(el.dataset.count) || 0;
      var pct = (rating / 5 * 100).toFixed(1);
      var fill = el.querySelector('.jlb-card-rating__stars-fill');
      var countEl = el.querySelector('.jlb-card-rating__count');
      if (fill) fill.style.width = pct + '%';
      if (countEl) countEl.textContent = '(' + count + ')';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-contact"] && !Shopify.designMode) return;
  try {
    
  // FAQ accordion
  document.querySelectorAll('[data-faq]').forEach(item => {
    const btn = item.querySelector('.jlb-ct-faq__question');
    const answer = item.querySelector('.jlb-ct-faq__answer');
    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      // Ferme tous les autres
      document.querySelectorAll('[data-faq]').forEach(other => {
        other.querySelector('.jlb-ct-faq__question').setAttribute('aria-expanded', 'false');
        other.querySelector('.jlb-ct-faq__answer').style.maxHeight = '0';
      });
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-cuisine"] && !Shopify.designMode) return;
  try {
    
  // Carousel
  const track = document.getElementById('jlbCuTrack');
  const prev  = document.getElementById('jlbCuPrev');
  const next  = document.getElementById('jlbCuNext');
  if (track && prev && next) {
    let idx = 0;
    const cards = track.querySelectorAll('.jlb-cu-ess-card');
    const total = cards.length;
    function goTo(n) {
      idx = Math.max(0, Math.min(n, total - 1));
      const w = cards[0].offsetWidth + 24;
      track.style.transform = 'translateX(-' + (idx * w) + 'px)';
    }
    prev.addEventListener('click', () => goTo(idx - 1));
    next.addEventListener('click', () => goTo(idx + 1));
  }

  // Reveal on scroll
  const reveals = document.querySelectorAll('.jlb-cu-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-header"] && !Shopify.designMode) return;
  try {
    
  // Search overlay
  const searchToggle  = document.getElementById('jlbSearchToggle');
  const searchOverlay = document.getElementById('jlbSearchOverlay');
  const searchClose   = document.getElementById('jlbSearchClose');
  const searchBackdrop= document.getElementById('jlbSearchBackdrop');
  const searchInput   = document.getElementById('jlbSearchInput');

  function openSearch() {
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { searchInput.focus(); }, 100);
  }
  function closeSearch() {
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose)  searchClose.addEventListener('click', closeSearch);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
  });

  // Scroll shadow
  const hdr = document.getElementById('jlbHeader');
  if (hdr) {
    window.addEventListener('scroll', () => {
      hdr.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // Banner infinite marquee
  (function() {
    const track = document.getElementById('jlbBannerTrack');
    if (!track) return;
    // Measure one set of items
    const oneSetWidth = track.scrollWidth;
    // Clone until we have at least 3x viewport
    const copies = Math.ceil((window.innerWidth * 3) / oneSetWidth) + 1;
    for (let i = 0; i < copies; i++) {
      const fragment = document.createDocumentFragment();
      track.querySelectorAll('.jlb-hdr-banner__item, .jlb-hdr-banner__sep').forEach(function(el) {
        const clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        fragment.appendChild(clone);
      });
      track.appendChild(fragment);
    }
    let x = 0;
    const speed = 0.55;
    function tick() {
      x += speed;
      if (x >= oneSetWidth) x -= oneSetWidth;
      track.style.transform = 'translateX(-' + x + 'px)';
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  // Mobile drawer
  const burger  = document.getElementById('jlbBurger');
  const drawer  = document.getElementById('jlbDrawer');
  const overlay = document.getElementById('jlbDrawerOverlay');
  const closeBtn= document.getElementById('jlbDrawerClose');

  function openDrawer() {
    drawer.classList.add('is-open');
    burger.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-pack-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.jlb-pb');
    if (!root) return;
    var total = parseInt(root.getAttribute('data-slot-total'), 10) || 0;
    var selections = {}; // slotIndex -> { vid, price }

    var countEl = document.getElementById('jlbPbCount');
    var totalEl = document.getElementById('jlbPbTotal');
    var addBtn = document.getElementById('jlbPbAdd');
    var errEl = document.getElementById('jlbPbError');

    function euro(cents) {
      try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
      catch (e) { return (cents / 100).toFixed(2) + ' €'; }
    }

    function refresh() {
      var chosen = 0, sum = 0;
      Object.keys(selections).forEach(function (k) {
        if (selections[k]) { chosen++; sum += selections[k].price; }
      });
      if (countEl) countEl.textContent = chosen;
      if (totalEl) totalEl.textContent = chosen ? euro(sum) : '—';
      if (addBtn) addBtn.disabled = (chosen !== total || total === 0);
    }

    root.addEventListener('click', function (e) {
      var sw = e.target.closest('.jlb-pb__swatch');
      if (!sw || sw.disabled || sw.classList.contains('is-oos')) return;
      var slot = sw.getAttribute('data-slot');
      var group = sw.parentElement;
      group.querySelectorAll('.jlb-pb__swatch').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      sw.setAttribute('aria-pressed', 'true');
      selections[slot] = { vid: sw.getAttribute('data-vid'), price: parseInt(sw.getAttribute('data-price'), 10) || 0 };
      refresh();
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        // Group identical variants into quantities
        var qty = {};
        Object.keys(selections).forEach(function (k) {
          var vid = selections[k].vid;
          qty[vid] = (qty[vid] || 0) + 1;
        });
        var items = Object.keys(qty).map(function (vid) {
          return { id: Number(vid), quantity: qty[vid], properties: { '_Pack': 'Coffret Bain' } };
        });
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        addBtn.disabled = true;
        var prevLabel = addBtn.textContent;
        addBtn.textContent = 'Ajout en cours...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (res.ok) { window.location.href = '/cart'; return null; }
          return res.json().then(function (data) { throw new Error((data && data.description) || 'Un article est indisponible.'); });
        }).catch(function (err) {
          if (errEl) { errEl.hidden = false; errEl.textContent = err.message || 'Une erreur est survenue, réessayez.'; }
          addBtn.disabled = false;
          addBtn.textContent = prevLabel;
        });
      });
    }

    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-salle-de-bain"] && !Shopify.designMode) return;
  try {
    
  const track = document.getElementById('jlbSbTrack');
  const prev  = document.getElementById('jlbSbPrev');
  const next  = document.getElementById('jlbSbNext');
  if (track && prev && next) {
    let idx = 0;
    const cards = track.querySelectorAll('.jlb-sb-ess-card');
    const total = cards.length;
    function goTo(n) {
      idx = Math.max(0, Math.min(n, total - 1));
      const w = cards[0].offsetWidth + 24;
      track.style.transform = 'translateX(-' + (idx * w) + 'px)';
    }
    prev.addEventListener('click', () => goTo(idx - 1));
    next.addEventListener('click', () => goTo(idx + 1));
  }

  const reveals = document.querySelectorAll('.jlb-sb-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-salon"] && !Shopify.designMode) return;
  try {
    
  // Carousel
  const track = document.getElementById('jlbSlTrack');
  const prev  = document.getElementById('jlbSlPrev');
  const next  = document.getElementById('jlbSlNext');
  if (track && prev && next) {
    let idx = 0;
    const cards = track.querySelectorAll('.jlb-sl-ess-card');
    const total = cards.length;
    function goTo(n) {
      idx = Math.max(0, Math.min(n, total - 1));
      const w = cards[0].offsetWidth + 24;
      track.style.transform = 'translateX(-' + (idx * w) + 'px)';
    }
    prev.addEventListener('click', () => goTo(idx - 1));
    next.addEventListener('click', () => goTo(idx + 1));
  }

  // Reveal on scroll
  const reveals = document.querySelectorAll('.jlb-sl-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
